import { CreditCard, Smartphone } from "lucide-react";

import { platformLabel, platformStyle, type Platform } from "./platform";

export function PlatformBadge({ platform }: { platform: Platform }) {
  // A card reader, not a tablet: at 12px a Tablet glyph is the same rounded
  // rectangle as a Smartphone, which is the one distinction this badge exists
  // to make.
  const Icon = platform === "terminal" ? CreditCard : Smartphone;

  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${platformStyle(platform)}`}
    >
      <Icon className="h-3 w-3" />
      {platformLabel(platform)}
    </span>
  );
}
